import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Link, useLocation } from "react-router-dom";
import "../../../investor/investor.css";
import { AgGridReact } from "ag-grid-react";
import { SBDatePicker } from "../../../UiComponents/SBDatePicker";
import { SBGrid } from "../../../UiComponents/SBAAGgrid";
import { SBAMultiSelectCheck, SBAMultiColumnComboBox } from "../../../UiComponents/SBADropDown";
import moment from "moment";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { getActivitiesDetails } from "../../../actions/investmentAction";
import { getCustomSettings, getActivities, DownloadDocument, getTaxEntitiesByContact, getUserPageAccess } from "../../../../config/apiConfig";
import { sbaAxios } from "../../..//utils/sbaAxios";
import { DateRangePicker } from "rsuite";
import { getMultipleDocs } from "../../../actions/assetDocumentsActions";
import { getAssetNoteDetails } from "../../../actions/assetNotestabAction";
import { getInvestorActivitiesAction } from "../../../actions/investorAccounts";
import { SBDateRangePicker } from "../../../UiComponents/SBDateRangePicker";
import { UrlPath } from "../../../../config/routeConfig";
export const Reporting = (props) => {
  const locationData = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  const documentListRef = useRef();
  const history=useNavigate();
 
    const Gstate = useSelector((state) => state) || {};
    const isEditable = Gstate.authorizationData.isEditable;
    const [activitytype, Setactivitytype] = useState();
    const [accountids, Setaccountids] = useState([]);
    const activitesGridLoading = Gstate?.investorAccounts.isInvestorActivitiesDetailsLoading;
    const activities = Gstate?.investorAccounts.InvestorActivitiesDetails || [];
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    const [StartDate, setStartDate] = useState(oneMonthAgo);
    const [EndDate, setEndDate] = useState(new Date());
    const [Subject, setSubject] = useState(null);
    const [dateRange, setDateRange] = useState([new Date(oneMonthAgo), new Date()]);
    const [clientReportingEdit,setClientReportingEdit]=useState(false);
    const getAccessForEdit = async () => {
        try {
            const response = await sbaAxios({ url:  `${getUserPageAccess}?keyName=ClientReportingEditAccess` });
            setClientReportingEdit(response);            
        } catch (error) {
        }
    };
    useEffect(() => {
        document.title = `Investor Details`;
        fetchGridData();
        getTaxEntities();
        getAccessForEdit();
    }, []);

    const getTaxEntities = async () => {
        try {

            const response = await sbaAxios({
                url: `${getTaxEntitiesByContact}${params.ContactId}`,
                method: 'get',
            });
            const data = response;
            
            const AccountIds = data?.map((acctype) => acctype.TaxEntityId);
            Setaccountids(AccountIds);
            dispatch(getInvestorActivitiesAction(params.ContactId, AccountIds, -1, StartDate.toISOString(),EndDate.toISOString(),5, Subject != null ? Subject : ""));

        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    };

    const storeDocuments = Gstate.mutipleDocuments?.mutipleDocuments || [];
    const gridValueFormatter = (params) => {
        return <input type='checkbox' checked={params.value} />;
    };
    const assetNameKeyCreator = (params) => {
        var data = params.data;
        return data.AssetName;
    };
    const dateKeyCreator = (params) => {
        var data = params.data;
        return moment(data.ActivityDate).format("MM/DD/YYYY");
    };
    const activityTypeNameKeyCreator = (params) => {
        var data = params.data;
        return data.ActivityType;
    };
    const subjectNameKeyCreator = (params) => {
        var data = params.data;
        return data.ActivityName;
    };
    const createdNameKeyCreator = (params) => {
        var data = params.data;
        return data.CreatedByName;
    };
    
    const checkBoxFormatter = (params) => {
        return <input type='checkbox' checked={params.value === true} disabled />;
    };
    const valuformaterapply = (params) => {
        return moment(params.value).format("MM/DD/YYYY");
    }

    const loadOnEnter = (event) => {
        if (event.key === 'Enter') {
            enterbtnClick()
        }
    };
    const entityTypeRenderer = (params) => {
        if (params.value === 0)
            return 'Contact';
        else if (params.value === 1)
            return 'Account';
        else
            return '';
    };
    const naviagteToInvestorEdit=(event)=>{
        const activityId=event.data.ActivityId || 0;
        if(activityId)
        {
            history(`${UrlPath.DocumentInvestorEdit}${activityId}`,   {
                state: {
                    from: locationData.pathname,
                    activeTab:"ClientReporting"
                }
            });
        }

    }
    const ActionsRenderer = (event,clientReportingEdit) => {
        return (<div className="actions-cell">
        <i className="fas fa-edit" style={{ color:  clientReportingEdit === false ? "#808080" : "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={()=>{clientReportingEdit && naviagteToInvestorEdit(event)}}></i>        
    </div>)
    };
    
    const columnDefs = [
        
        {
            field: "AssetName",
            headerName: "Asset",
            // filter: "agSetColumnFilter",
            valueFormatter: gridValueFormatter,
            filterParams: {
                keyCreator: assetNameKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'AssetName'
        },
        {
            field: "Portfolios",
            headerName: "Portfolios",
            filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Portfolios'
        },
        {
            field: "Substrategies",
            headerName: "Sub Strategies",
            //  filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Substrategies'
        },
        {
            field: "Managers",
            headerName: "Managers",
            filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Managers'
        },
        {
            field: "Contacts",
            headerName: "Contacts",
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Contacts'
        },
        {
            field: "Contributors",
            headerName: "Contributors",
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'Contributors'
        },
        {
            field: "ActivityDate",
            headerName: "Date",
            maxWidth: 130,
            //  filter: "agSetColumnFilter",
            valueFormatter: (params) => {
                return moment(params.value).format("MM/DD/YYYY");
            },
            filterParams: {
                keyCreator: dateKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'ActivityDate'
        },
        {
            field: "ActivityType",
            headerName: "Type",
            maxWidth: 150,
            //  filter: "agSetColumnFilter",
            valueFormatter: gridValueFormatter,
            filterParams: {
                keyCreator: activityTypeNameKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'ActivityType'
        },
        {
            field: "ActivitySubType",
            headerName: "ActivitySubType",
            maxWidth: 130,
            //  filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            tooltipField: 'ActivitySubType'
        },
        {
            field: "ActivityName",
            headerName: "Subject",
            // filter: "agSetColumnFilter",
            valueFormatter: gridValueFormatter,
            filterParams: {
                keyCreator: subjectNameKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'ActivityName'
        },
        {
            field: "IsQuarterlyLetter",
            headerName: "Is Partner Letter",
            maxWidth: 130,
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            filterParams: {
                filterDefault: false,
            },
            tooltipField: 'IsQuarterlyLetter'
        },
        {
            field: "IsMarketCommentary",
            headerName: "Is Manager Letter",
            maxWidth: 130,
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: gridValueFormatter,
            filterParams: {
                filterDefault: false,
            },
            tooltipField: 'IsMarketCommentary'
        },
        {
            field: "CreatedByName",
            headerName: "Created by",
            maxWidth: 130,
            // filter: "agSetColumnFilter",
            valueFormatter: gridValueFormatter,
            filterParams: {
                keyCreator: createdNameKeyCreator,
                convertValuesToStrings: true,
            },
            tooltipField: 'CreatedByName'
        },
        {
            field: "CreatedDate",
            headerName: "Created Date",
            maxWidth: 130,
            // filter: "agSetColumnFilter",
            hide: true,
            valueFormatter: (params) => {
                return moment(params.value).format("MM/DD/YYYY");
            },
            tooltipField: 'CreatedDate'
        },
        {
            field: "Action",
            headerName: "Action",
            cellRenderer: ActionsRenderer,
            filter: false,
            maxWidth: 130,
        },
    ];

    const getCustomSetting = async () => {
        try {
            const response = await sbaAxios({ url: `${getCustomSettings}1013` });
            const ClientReportingEditAccess=await sbaAxios({ url:  `${getUserPageAccess}?keyName=ClientReportingEditAccess` });

            if (response) {
                const apiColDef = JSON.parse(response.CustomSettingsValue);
                const filterOptions = response.CustomFilterValue.trim() !== "" ? JSON.parse(response.CustomFilterValue) : null;
                
                const isProcessedIndex = apiColDef.findIndex((item) => item.colId === "IsProcessed");

                if (isProcessedIndex === -1) {
                    const isProcessedColumn = {
                        colId: "IsProcessed",
                        width: 100,
                        headerName: "Is Processed",
                        hide: false,
                        pinned: null,
                        sort: null,
                        sortIndex: null,
                        aggFunc: null,
                        rowGroup: false,
                        rowGroupIndex: null,
                        pivot: false,
                        pivotIndex: null,
                        flex: 1
                    };
                    const insertIndex = apiColDef.length > 0 ? apiColDef.length - 2 : 0;
                    apiColDef.splice(insertIndex, 0, isProcessedColumn);
                } else if (isProcessedIndex === apiColDef.length - 1) {
                    const [isProcessedColumn] = apiColDef.splice(isProcessedIndex, 1);
                    apiColDef.splice(apiColDef.length - 2, 0, isProcessedColumn);
                }
                
                const formattedDef = apiColDef.map(item => ({
                    ...item,
                    "field": item.colId,
                    cellRenderer: item.colId === "Action" ? (e)=>ActionsRenderer(e,ClientReportingEditAccess) : item.colId === "IsMarketCommentary" ? checkBoxFormatter : item.colId === "IsQuarterlyLetter" ? checkBoxFormatter : item.colId === "ActivityDate" ? valuformaterapply : item.colId === "CreatedDate" ? valuformaterapply : item.colId === "EntityTypeId" ? entityTypeRenderer :  item.colId === "IsProcessed" ? 'agCheckboxCellRenderer': null,
                    "headerName": item.colId === "ActivityDate" ? "Document Date" : item.colId === "ActivitySubType" ? "Document Type" : item.colId === "ActivityName" ? "Document Name" : null,
                }));
                return { columns: formattedDef, filters: filterOptions };
            }
        } catch (error) {
            console.log(error);
            throw error; // Re-throw the error to handle it elsewhere if needed
        }
    };

    const fetchGridData = async () => {
        try {
            const customSettings = await getCustomSetting();
            setColDef(customSettings.columns);
            setAppliedFilter(customSettings.filters);
        } catch (error) {
            console.error("Error fetching custom settings:", error);
        }
    };
    const handleDateChange = (e) => {
        if (e) {
            const newStartDate = e.value.start !== null ? e.value.start : dateRange[0];
            const newEndDate = e.value.end !== null ? e.value.end : dateRange[1];
            setDateRange([newStartDate, newEndDate])
            setStartDate(newStartDate);
            setEndDate(newEndDate);
        }
    };
    const subjectChange = (event) => {
        setSubject(event.target.value);
    };
    const customRanges = [
        {
            label: 'Last 30 Days',
            value: [new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
            new Date(),],
        },

        {
            label: 'Last 90 Days',
            value: [
                new Date(new Date().getTime() - 90 * 24 * 60 * 60 * 1000),
                new Date(),
            ],
        },
        {
            label: 'YTD',
            value: [
                new Date(new Date().getFullYear(), 0, 1),
                new Date(),
            ],
        },

    ];

    const isRowSelectable = useMemo(() => {
        return (params) => {
            return !!params.data && params.data.NumOfAttachements > 0;
        };
    }, []);


    const [colDef, setColDef] = useState([])
    const [appliedFilter, setAppliedFilter] = useState({})

    const enterbtnClick = () => {
        if (StartDate === null && EndDate === null) {
            setStartDate(new Date());
            setEndDate(new Date());
        }
        let start = StartDate.toISOString();
        let end = EndDate.toISOString();


        dispatch(getInvestorActivitiesAction(params.ContactId, accountids,-1, start, end, 5, Subject != null ? Subject : ""));
        fetchGridData();

    };

    const ClearbtnClick = () => {
        setSubject(null);
        setEndDate(new Date());
        setStartDate(oneMonthAgo);
        dispatch(getInvestorActivitiesAction(params.ContactId, accountids, -1, StartDate.toISOString(), EndDate.toISOString(), 5,""));

    };

    const handleRowDoubleClicked = (row) => {
        handleLinkClick(row)
        try {
            const documentId = storeDocuments[0].DocumentId;
            const documentName = storeDocuments[0].DocumentName;
            const urlBuild = DownloadDocument + btoa(documentId.toString());
            sbaAxios({ url: urlBuild }).then((response) => {
                window.open(urlBuild);
            });
        } catch (error) {
            console.error("Error opening document:", error);
        }
    };
   
    const handleLinkClick = (row) => {
        const ActivityId = row.data.ActivityId;
        dispatch(getMultipleDocs(ActivityId));
        dispatch(getAssetNoteDetails(ActivityId));
    };

  return (
    <>            
              <div id="content">
                  <div className="bg-white m-3 mb-3 p-3 border rounded">
                  <div className="row">
                                                                                          
                      <div className="col-md-3">
                          <label
                              for="select fund"
                              className="mb-1 ms-2 fw-semibold fs-12"
                          >
                              Date Range
                          </label>
                          <SBDateRangePicker
                              value={{ start: dateRange[0], end: dateRange[1] }}
                              onChange={(e) => { handleDateChange(e) }}

                          />
                          {/*<DateRangePicker*/}
                          {/*    className="SbaDateRage text-dark"*/}
                          {/*    placeholder="Select Date Range"*/}
                          {/*    value={[*/}
                          {/*        StartDate ? moment(StartDate).toDate() : null,*/}
                          {/*        EndDate ? moment(EndDate).toDate() : null,*/}
                          {/*    ]}*/}
                          {/*    format="MM/dd/yyyy"*/}
                          {/*    onChange={handleDateChange}*/}
                          {/*    block*/}
                          {/*    character=" - "*/}
                          {/*    ranges={customRanges}*/}
                          {/*/>*/}
                      </div>                                        

                     <div className="col-md-3">
                          <label
                              for="select fund"
                              className="mb-1 ms-2 fs-12 fw-semibold"
                          >
                              Document Name
                          </label>
                      <input
                          className="w-75 input-default form-control"
                          type="text"
                          placeholder="Type here"
                          onChange={subjectChange}
                          value={Subject ? Subject : ''}
                          onKeyUp={loadOnEnter}
                      />
                      </div>

                      {/* <div className="col-md-3">
                          <label
                              for="select fund"
                              className="mb-1 ms-2 fs-12 fw-semibold"
                          >
                              Description
                                    </label>
                          <input
                              className="w-75 input-default form-control"
                              type="text"
                              placeholder="Type here"
                              onChange={subjectChange}
                              value={Subject ? Subject : ''}
                              onKeyUp={loadOnEnter}
                          />
                      </div> */}

                  <div className="mt-3">
                      <button
                          type="button"
                          className="enter-btn"
                          onClick={enterbtnClick}
                      >
                              Enter
                                </button>
                          <button type="button" className="cancel-btn ms-2" onClick={ClearbtnClick}>
                              Clear All
                                </button>
                     
                  </div>
                  </div>
                  </div>
             
                  <div className="d-flex justify-content-between align-items-start px-3">
                  {activitesGridLoading ? (
                      <LoadingScreen />
                  ) : (
                      <>
                          <SBGrid ref={documentListRef} column={colDef} row={activities} pageSize={15} rowSelection="single" filters={appliedFilter} componentID={1013} gridStyle={{ width: '100%', height: '700px' }} isRowSelectable={isRowSelectable} onRowDoubleClicked={handleRowDoubleClicked}></SBGrid>
                      </>
                  )}

              </div>
          </div>
         
         
          
    </>
  );
};
